var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.46756 0.266515L4.99553 3.80182L1.52349 0.266515C1.1745 -0.0888383 0.610738 -0.0888383 0.261745 0.266515C-0.0872483 0.621868 -0.0872483 1.1959 0.261745 1.55125L4.36913 5.73349C4.71812 6.08884 5.28188 6.08884 5.63087 5.73349L9.73825 1.55125C10.0872 1.1959 10.0872 0.621868 9.73825 0.266515C9.38926 -0.0797267 8.81656 -0.0888383 8.46756 0.266515Z",
    fill: "#B4B5B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.137c558ec52f3bf6a530a7f0b879e410.svg";
export { ForwardRef as ReactComponent };